import { NavLink } from "react-router-dom";
import {
  UsersRound,
  Store,
  IdCard,
  GitPullRequestCreateArrow,
  Gift,
  FileChartColumnIncreasing
} from "lucide-react";
// import { useAuth } from "../context/AuthContext";

export default function LoyaltyReport() {
  // const { user } = useAuth();
  // console.log(user);
  return (
    <>
      <div className="grid grid-flow-col grid-rows-3 gap-4">
        <div className="row-start-1 row-end-4"><h2 className="text-2xl font-bold mb-4">Report Card</h2></div>
        
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mt-4">

       {/* { icon: <IdCard size={24} />, label: "Earning By Card", pageurl: "earningbycustomer" },
          { icon: <Gift size={24} />, label: "Earning By Reward", pageurl: "#" }, */}

        {[
          { icon: <UsersRound size={24} />, label: "Customers Wise", pageurl: "customer" },
          { icon: <Store size={24} />, label: "Stores Wise", pageurl: "store" },
          { icon: <Gift size={24} />, label: "Rewards Wise", pageurl: "reward" },
          { icon: <UsersRound size={24} />, label: "Earning By Customer", pageurl: "earningbycustomer" },
         
        ].map((item, index) => (
          <NavLink to={item.pageurl} key={index}>
            <div className="p-4 bg-white rounded-xl shadow flex flex-col items-center hover:shadow-md transition">
              <div className="text-blue-500">{item.icon}</div>
              <p className="mt-2 text-sm font-medium text-gray-700 text-center">
                {item.label}
              </p>
            </div>
          </NavLink>
        ))}
      </div>
    </>
  );
}
